
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ControlsTree from "@/components/Reusable/ControlsTree/ControlsTree.vue";
import { Control } from "@/types/controls";

@Component({
  components: {
    ControlsTree
  }
})
export default class DesignTabContent extends Vue {
  @Prop()
  controls!: Control[];

  @Prop()
  path!: string;
}
